module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Volume-half-f1ee31d3598206e3880110a3db21bbe4.svg";